import cx from 'classnames';
import React from 'react';

import * as styles from './styles.less';

interface Props {
    className?: string;
    imageURL: string;
    title: string;
    url: string;
}

const FeaturedShow: React.SFC<Props> = props => (
    <a
        className={ cx(styles.root, props.className) }
        href={ props.url }
    >
        <img
            className={ styles.image }
            src={ props.imageURL }
            title={ props.title }
        />
    </a>
);

export default FeaturedShow;
